import { render } from "./OpenProject.vue?vue&type=template&id=95f031d6&scoped=true&ts=true"
import script from "./OpenProject.vue?vue&type=script&lang=ts"
export * from "./OpenProject.vue?vue&type=script&lang=ts"

import "./OpenProject.vue?vue&type=style&index=0&id=95f031d6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95f031d6"]])

export default __exports__